module.exports = __webpack_public_path__ + "img/1-05.e0a91273.svg";